'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448 from "./presto.types$-Credential-Name$$anon$48.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449 from "./presto.types$-Credential-Name$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialName$() {
  this.c48 = null;
  this.c49 = false;
  this.c46 = null;
  this.c47 = false;
  this.c4c = null;
  this.c4d = false;
  this.c4a = null;
  this.c4b = false;
  this.c4e = null;
  this.c4f = false;
}
export { $c_Lpresto_types$CredentialName$ as $c_Lpresto_types$CredentialName$ };
$p = $c_Lpresto_types$CredentialName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialName$;
/** @constructor */
function $h_Lpresto_types$CredentialName$() {
}
export { $h_Lpresto_types$CredentialName$ as $h_Lpresto_types$CredentialName$ };
$h_Lpresto_types$CredentialName$.prototype = $p;
$p.crx = (function() {
  if ((!this.c49)) {
    this.c48 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c49 = true;
  }
  return this.c48;
});
$p.gl = (function() {
  if ((!this.c47)) {
    this.c46 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c47 = true;
  }
  return this.c46;
});
$p.adq = (function() {
  if ((!this.c4d)) {
    this.c4c = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4d = true;
  }
  return this.c4c;
});
$p.a2u = (function() {
  if ((!this.c4b)) {
    this.c4a = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448.$c_Lpresto_types$CredentialName$$anon$48(this);
    this.c4b = true;
  }
  return this.c4a;
});
$p.Gx = (function() {
  if ((!this.c4f)) {
    this.c4e = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449.$c_Lpresto_types$CredentialName$$anon$49(this);
    this.c4f = true;
  }
  return this.c4e;
});
var $d_Lpresto_types$CredentialName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialName$, "presto.types$CredentialName$", ({
  Zi: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialName$ as $d_Lpresto_types$CredentialName$ };
var $n_Lpresto_types$CredentialName$;
function $m_Lpresto_types$CredentialName$() {
  if ((!$n_Lpresto_types$CredentialName$)) {
    $n_Lpresto_types$CredentialName$ = new $c_Lpresto_types$CredentialName$();
  }
  return $n_Lpresto_types$CredentialName$;
}
export { $m_Lpresto_types$CredentialName$ as $m_Lpresto_types$CredentialName$ };
//# sourceMappingURL=presto.types$-Credential-Name$.js.map
